import { Prec } from '@codemirror/state'
import { keymap } from '@codemirror/view'
import * as Actions from './actions'

export const markdownShortcuts = Prec.high(
  keymap.of([
    {
      key: 'Mod-b',
      run: view => {
        Actions.wrapContent(view, '**', '**')
        return true
      }
    },
    {
      key: 'Mod-i',
      run: view => {
        Actions.wrapContent(view, '*', '*')
        return true
      }
    },
    {
      key: 'Mod-u',
      run: view => {
        Actions.wrapContent(view, '<u>', '</u>')
        return true
      }
    },
    {
      key: 'Mod-Shift-x',
      run: view => {
        Actions.wrapContent(view, '~', '~')
        return true
      }
    },
    {
      key: 'Mod-e',
      run: view => {
        Actions.wrapContent(view, '`', '`')
        return true
      }
    },
    {
      key: 'Mod-k',
      run: view => {
        Actions.insertLink(view)
        return true
      }
    },
    {
      key: 'Mod-.',
      run: view => {
        Actions.wrapContent(view, '<sup>', '</sup>')
        return true
      }
    },
    {
      key: 'Mod-,',
      run: view => {
        Actions.wrapContent(view, '<sub>', '</sub>')
        return true
      }
    },
    {
      key: 'Mod-Shift-e',
      run: view => {
        Actions.insertEquation(view)
        return true
      }
    }
  ])
)

export const formatShortcut = (shortcut: string, isMac: boolean) => {
  const parts = shortcut.split('-')
  const mapped = parts.map(part => {
    if (part === 'Mod') return isMac ? '⌘' : 'Ctrl'
    if (part === 'Shift') return isMac ? '⇧' : 'Shift'
    if (part === 'Alt') return isMac ? '⌥' : 'Alt'
    return part.length === 1 ? part.toUpperCase() : part
  })
  return isMac ? mapped.join('') : mapped.join('+')
}

export const getShortcutTooltip = (shortcut: string | undefined, isMac: boolean) => {
  if (!shortcut) return ''
  return `(${formatShortcut(shortcut, isMac)})`
}

export const isMacPlatform = (): boolean => {
  const nav = globalThis.navigator
  if (!nav) return false

  const uaData = (nav as Navigator & { userAgentData?: { platform?: string } }).userAgentData

  if (uaData?.platform) {
    return uaData.platform === 'macOS'
  }
  const ua = nav.userAgent
  return ua.includes('Macintosh') || ua.includes('iPhone') || ua.includes('iPad')
}
